import { FONT_CATALOG } from "./catalog";
import type { FontLoadRequirements, FontSourceFile, FontStyle, FontVariant } from "./types";

export const DEFAULT_FONT_FAMILY = "Open Sans";
export const DEFAULT_FONT_REQUIREMENTS: FontLoadRequirements = {
    weights: new Set<number>([400]),
    styles: new Set<FontStyle>(["normal"]),
};

const FONT_VARIANTS: Record<FontVariant, { weight: number; style: FontStyle }> = {
    regular: { weight: 400, style: "normal" },
    bold: { weight: 700, style: "normal" },
    italic: { weight: 400, style: "italic" },
    "bold-italic": { weight: 700, style: "italic" },
};

const FONTS_API_PREFIX = "/api/v2/static/media/fonts";

const buildFontFileUrl = (fontDir: string, variant: FontVariant): string => {
    return `${FONTS_API_PREFIX}/${encodeURIComponent(fontDir)}/${variant}.woff2`;
};

const buildFontFiles = (
    fontDir: string,
    variants: FontVariant[] = ["regular", "bold", "italic"],
) => {
    return variants.map((variant) => ({
        url: buildFontFileUrl(fontDir, variant),
        weight: FONT_VARIANTS[variant].weight,
        style: FONT_VARIANTS[variant].style,
    }));
};

export const FONT_REGISTRY: Record<string, FontSourceFile[]> = Object.fromEntries(
    FONT_CATALOG.map(({ family, slug, variants }) => [family, buildFontFiles(slug, variants)]),
);
